import React from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { Button } from './ui/button';
import { X, Plus, Minus, ShoppingBag } from 'lucide-react';

const CartDrawer = () => {
  const { items, setQty, remove, total, count, open, setOpen } = useCart();
  const nav = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="bg-[#faf7f1] w-full sm:max-w-md p-0 flex flex-col">
        <SheetHeader className="p-6 border-b border-neutral-200">
          <SheetTitle className="font-serif text-2xl text-[#1a2b17] flex items-center gap-2">
            <ShoppingBag className="w-5 h-5" /> Your cart ({count})
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {items.length === 0 && <p className="text-[#7a8471] text-center mt-10">Your cart is empty.</p>}
          {items.map((i) => (
            <div key={i.id} className="flex gap-3 bg-white rounded-2xl p-3">
              <img src={i.image} alt={i.name} className="w-20 h-20 rounded-xl object-cover" />
              <div className="flex-1">
                <div className="flex justify-between">
                  <div className="text-sm font-medium text-[#1a2b17] pr-2">{i.name}</div>
                  <button onClick={() => remove(i.id)} className="text-[#7a8471] hover:text-red-500"><X className="w-4 h-4" /></button>
                </div>
                <div className="text-sm text-[#c9743a] mt-1">₹{i.price}</div>
                <div className="mt-2 inline-flex items-center gap-2 bg-[#faf7f1] rounded-full px-2 py-1">
                  <button onClick={() => setQty(i.id, i.qty - 1)} className="w-6 h-6 rounded-full hover:bg-white flex items-center justify-center"><Minus className="w-3 h-3" /></button>
                  <span className="text-sm w-6 text-center">{i.qty}</span>
                  <button onClick={() => setQty(i.id, i.qty + 1)} className="w-6 h-6 rounded-full hover:bg-white flex items-center justify-center"><Plus className="w-3 h-3" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-neutral-200 p-6 bg-white">
            <div className="flex justify-between mb-4">
              <span className="text-[#4a5544]">Total</span>
              <span className="font-serif text-2xl text-[#1a2b17]">₹{total}</span>
            </div>
            <Button onClick={() => { setOpen(false); nav('/checkout'); }} className="w-full h-12 rounded-full bg-[#3a5a2c] hover:bg-[#2d4622] text-white">Checkout</Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartDrawer;
